import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './style.module.less';
import messages from '../../../fulfillment-planner/labeled-row/messages';

export const ReturnError = ({ returnError }) => {
  if (returnError == null || returnError === 'None') {
    return null;
  }

  return (
    <BannerMessageV2
      className={classnames(style['error-banner'])}
      content={<FormattedMessage {...messages.rateErrorBody} />}
      status={BannerStatus.Warning}
    />
  );
};

ReturnError.propTypes = {
  returnError: PropTypes.string.isRequired,
};
